module.exports = require("graphql-subscriptions");